<script setup lang="ts">
const props = defineProps<{
  color: string;
}>();
</script>
<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="none"
  >
    <path
      d="M2.14282 7.23227L9.75282 11.1901C9.82916 11.2298 9.91393 11.2505 9.99997 11.2505C10.086 11.2505 10.1708 11.2298 10.2471 11.1901L17.8571 7.23298V14.108C17.8571 14.7009 17.6303 15.2714 17.2231 15.7024C16.8158 16.1334 16.2591 16.3923 15.6671 16.4258L15.5357 16.4294H4.46425C3.8713 16.4294 3.3008 16.2026 2.8698 15.7954C2.4388 15.3881 2.17996 14.8314 2.14639 14.2394L2.14282 14.108V7.23227ZM4.46425 3.57227H15.5357C16.1286 3.57223 16.6991 3.79909 17.1301 4.20632C17.5611 4.61354 17.82 5.17026 17.8535 5.76227L17.8571 5.89369V6.02512L9.99997 10.1108L2.14282 6.02512V5.89369C2.14278 5.30074 2.36965 4.73025 2.77687 4.29924C3.1841 3.86824 3.74082 3.60941 4.33282 3.57584L4.46425 3.57227H15.5357H4.46425Z"
      :fill="color"
    />
  </svg>
</template>
